import bFormGroup from './form-group';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bFormGroup: bFormGroup,
  bFormFieldset: bFormGroup
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-group/index.js
// module id = hi16
// module chunks = 17